import React from 'react';

import Checkbox from '@gogame/ui/Checkbox';

import ListItem from '@gogame/ui/ListItem';
import ListItemIcon from '@gogame/ui/ListItemIcon';
import ListItemSecondaryAction from '@gogame/ui/ListItemSecondaryAction';
import ListItemText from '@gogame/ui/ListItemText';
import Stack from '@gogame/ui/Stack';
import Typography from '@gogame/ui/Typography';
import { blend, useTheme } from '@gogame/ui/styles';
import Prefix from './Prefix';

export const dataCy = 'virtualized-list-row';

export const dataCyTitle = 'virtualized-list-row-title';
export const dataCyAction = 'virtualized-list-row-action';
export const dataCyActionCheckbox = 'virtualized-list-row-action-checkbox';

export const HANDLE_WIDTH = 12;

const BaseListItem = React.forwardRef(
  (
    {
      handle,
      // rowHeight,
      primaryLabel,
      primaryTooltip,
      actionCount,
      secondaryAction,
      icon,
      checkbox,
      // checked,
      secondaryLabel,
      secondaryTooltip,

      // isAllChecked,
      // count,
      button,
      selected,
      changed,
      // state = { expanded: false },
      // style: { marginLeft, ...style },
      style,
      onChange,
      onClick,
      // gutterLabel,
      divider,

      // labelWrap  = true,
      // isTreeData,
      className,
      disabled,
      labelWrap,
      showIcon,
      sticky,
      position,
      holder,
      depth = 0,
    },
    ref
  ) => {
    const theme = useTheme();
    // const [ref, hovered] = useHover();

    // const iconWithHover = icon &&  React.cloneElement(icon, {
    //   hovered,
    // });

    const handleCLick = () => {
      if (onClick) {
        onClick();
      }
    };

    const paddingLeft = (depth + 1) * 16;

    return (
      <ListItem
        component={'div'}
        button={button}
        disabled={disabled}
        divider={divider}
        selected={selected}
        ContainerComponent={'div'}
        actionCount={actionCount}
        onClick={disabled ? undefined : handleCLick}
        data-cy={dataCy}
        ContainerProps={{
          style: {
            height: '100%',
          },
        }}
        style={{
          ...style,
          boxSizing: 'border-box',
          paddingLeft: handle ? paddingLeft + HANDLE_WIDTH : paddingLeft,
          height: '100%',
          ...(changed
            ? {
                backgroundColor: blend(
                  theme.palette.background.default,
                  theme.palette.pending.main,
                  theme.palette.action.focusOpacity,
                  1
                ),
              }
            : null),
        }}
      >
        {handle}
        {showIcon ? (
          <Prefix>
            {icon ? (
              <ListItemIcon style={{ minWidth: 10 }}>{icon} </ListItemIcon>
            ) : null}
          </Prefix>
        ) : null}

        {checkbox ? (
          <ListItemIcon>
            <Checkbox
              edge={'start'}
              checked={selected}
              tabIndex={-1}
              disableRipple
              disabled={disabled}
              data-cy-action={dataCyActionCheckbox}
            />
          </ListItemIcon>
        ) : null}

        <ListItemText
          disableTypography={true}
          primary={
            <Typography
              noWrap={labelWrap}
              variant={'body1'}
              tooltipText={primaryTooltip}
              disableTooltip={!primaryTooltip}
              lineClamp={2}
              data-cy={dataCyTitle}
            >
              {primaryLabel}
            </Typography>
          }
          secondary={
            secondaryLabel ? (
              <Stack direction={'row'}>
                <Typography
                  noWrap={true}
                  variant={'body2'}
                  color={'textSecondary'}
                  wrapper={true}
                  tooltipText={secondaryTooltip}
                  disableTooltip={!secondaryTooltip}
                  tooltipProps={{
                    placement: 'bottom-start',
                  }}
                >
                  {secondaryLabel}
                </Typography>
              </Stack>
            ) : null
          }
        />
        {secondaryAction ? (
          <ListItemSecondaryAction data-cy={dataCyAction} stopPropagation>
            {secondaryAction}
          </ListItemSecondaryAction>
        ) : null}
      </ListItem>
    );
  }
);

export default BaseListItem;
